import { gql } from 'graphql-request'

export const REMOVE_BOOK_PROMOTION = gql`
  mutation RemoveBookPromotion($bookId: Int!) {
    removeBookPromotion(bookId: $bookId) {
      id
    }
  }
`
